// Pagina clientes

import React, { useState, useEffect, useContext } from 'react';
import { Container, Row, Col, Card, Button, Form, Table, InputGroup, Badge, Spinner } from 'react-bootstrap';
import { FaSearch, FaPlus, FaEdit, FaTrash, FaFilter, FaSave, FaTimes, FaMapMarkerAlt } from 'react-icons/fa';
// import { db } from '../../services/firebaseConnection';
import { useFirebaseConnection } from '../../services/useFirebaseConnection';
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
} from 'firebase/firestore';
import { setDoc, getDoc } from 'firebase/firestore';
import { toast } from 'react-toastify';


// Formatador de moeda
const formatCurrency = (value) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(value);
};

const createAsaasCustomer = async (clienteData) => {
  
  const ASAAS_API_URL = 'https://webhookn8nprimeiro.grempresas.com.br/webhook/criar-cliente-84267beb-5cf3-470c-ba09-d26c5b3a18ee'; 

  try {
    const response = await fetch(`${ASAAS_API_URL}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        name: clienteData.nome,
        cpfCnpj: clienteData.cnpj.replace(/[^\d]+/g, ''),
        email: clienteData.email,
        phone: clienteData.telefone, // Assumindo que telefone é o phone fixo
        mobilePhone: clienteData.telefone, // Assumindo que telefone é o mobilePhone
        address: clienteData.rua,
        addressNumber: clienteData.numero,
        complement: clienteData.complemento,
        province: clienteData.bairro,
        postalCode: clienteData.cep.replace(/\D/g, ''),
        city: clienteData.cidade,
        state: clienteData.estado,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error('Erro ao criar cliente no Asaas:', errorData);
      toast.error(`Erro Asaas: ${errorData.errors[0].description || 'Falha desconhecida'}`);
      return null;
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Erro na requisição Asaas:', error);
    toast.error('Erro de rede ao conectar com Asaas.');
    return null;
  }
};

function Clientes() {
  const [clientes, setClientes] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [currentCliente, setCurrentCliente] = useState(null);
  const { db } = useFirebaseConnection();
  
const filteredClientes = clientes.filter(cliente => {
  // Convertemos o termo de busca uma única vez para performance
  const search = searchTerm.toLowerCase();

  return (
    // Usamos ?. para verificar se existe e ?? '' para caso seja nulo/undefined
    (cliente.nome?.toLowerCase() ?? '').includes(search) ||
    (cliente.cnpj ?? '').includes(searchTerm) ||
    (cliente.email?.toLowerCase() ?? '').includes(search) ||
    (cliente.rua?.toLowerCase() ?? '').includes(search) ||
    (cliente.bairro?.toLowerCase() ?? '').includes(search) ||
    (cliente.cidade?.toLowerCase() ?? '').includes(search) ||
    (cliente.estado?.toLowerCase() ?? '').includes(search) ||
    (cliente.cep ?? '').includes(searchTerm)
  );
});
  
const handleSaveCliente = async (cliente) => {

  const cnpjClean = cliente.cnpj.replace(/[^\d]+/g, '');

  if (!cnpjClean) {
    alert('CNPJ é obrigatório.');
    return;
  }

  try {
    // Verificar se é edição baseado no documentId (que vem do Firebase)
    if (cliente.documentId) {
      // É uma edição - atualizar documento existente
      console.log('Editando cliente com documentId:', cliente.documentId);
      
      const clienteRef = doc(db, 'clientes', cliente.documentId);
      await updateDoc(clienteRef, {
        nome: cliente.nome,
        cnpj: cliente.cnpj,
        email: cliente.email,
        telefone: cliente.telefone,
        status: cliente.status,
        rua: cliente.rua,
        numero: cliente.numero,
        complemento: cliente.complemento,
        bairro: cliente.bairro,
        cep: cliente.cep,
        cidade: cliente.cidade,
        estado: cliente.estado
      });
      
      // Atualizar estado local
      setClientes(clientes.map(c => 
        c.documentId === cliente.documentId 
          ? { ...cliente, documentId: cliente.documentId }
          : c
      ));
      
  } else {
      // É um novo cliente - verificar duplicidade
      console.log('Criando novo cliente');
      
      const clienteRef = doc(db, 'clientes', cnpjClean);
      const existingDoc = await getDoc(clienteRef);

      if (existingDoc.exists()) {
        toast.error('Já existe um cliente cadastrado com este CNPJ.');
        return;
      }

      // Criar novo cliente
      const novoCliente = {
        nome: cliente.nome,
        cnpj: cliente.cnpj,
        email: cliente.email,
        telefone: cliente.telefone,
        status: cliente.status,
        rua: cliente.rua,
        numero: cliente.numero,
        complemento: cliente.complemento,
        bairro: cliente.bairro,
        cep: cliente.cep,
        cidade: cliente.cidade,
        estado: cliente.estado
      };

      await setDoc(clienteRef, novoCliente);
      createAsaasCustomer(novoCliente);
      toast.success('Cliente criado com sucesso!');
    }

    setShowForm(false);
    setCurrentCliente(null);
    
    
    
  } catch (error) {
    console.error('Erro ao salvar cliente:', error);
    alert('Erro ao salvar cliente. Tente novamente.');
  }
};


  
  // Função para excluir cliente
const handleDeleteCliente = async (documentId) => {
  if (window.confirm('Tem certeza que deseja excluir este cliente?')) {
    await deleteDoc(doc(db, 'clientes', documentId));
    setClientes(clientes.filter(c => c.documentId !== documentId));
  }
};

  
  // Função para editar cliente
  const handleEditCliente = (cliente) => {
    setCurrentCliente(cliente);
    setShowForm(true);
  };
  
  // Calcular totais
  const totalClientes = filteredClientes.length;
  const clientesAtivos = filteredClientes.filter(c => c.status === 'Ativo').length;
  const clientesInativos = filteredClientes.filter(c => c.status === 'Inativo').length;
  const clientesInadiplentes = filteredClientes.filter(c => c.status === 'Inadiplente').length;

  useEffect(() => {
    const fetchClientes = async () => {
      try {
        const clientesRef = collection(db, 'clientes');
        const snapshot = await getDocs(clientesRef);
        const data = snapshot.docs.map(doc => ({ 
          documentId: doc.id, // ID do documento no Firebase
          ...doc.data() 
        }));
        setClientes(data);
      } catch (error) {
        console.error('Erro ao carregar clientes:', error);
      }
    };

    fetchClientes();
  }, []);
  
  return (
    <Container fluid className="p-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1>Gerenciamento de Clientes</h1>
        <Button 
          variant="primary" 
          onClick={() => { setCurrentCliente(null); setShowForm(true); }}
        >
          <FaPlus className="me-2" /> Novo Cliente
        </Button>
      </div>
      
      {/* Cards de resumo */}
      <Row className="mb-4">
        <Col md={6} lg={3} className="mb-3">
          <Card className="h-100 shadow-sm">
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <div className="text-muted small">Total de Clientes</div>
                  <h3 className="mb-0">{totalClientes}</h3>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
        
        <Col md={6} lg={3} className="mb-3">
          <Card className="h-100 shadow-sm">
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <div className="text-muted small">Clientes Ativos</div>
                  <h3 className="mb-0">{clientesAtivos}</h3>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col md={6} lg={3} className="mb-3">
          <Card className="h-100 shadow-sm">
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <div className="text-muted small">Clientes inativos</div>
                  <h3 className="mb-0">{clientesInativos}</h3>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col md={6} lg={3} className="mb-3">
          <Card className="h-100 shadow-sm">
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <div className="text-muted small">Clientes Inadiplente</div>
                  <h3 className="mb-0">{clientesInadiplentes}</h3>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      
      {/* Barra de pesquisa */}
      <Card className="mb-4 shadow-sm">
        <Card.Body>
          <Row>
            <Col>
              <InputGroup>
                <InputGroup.Text>
                  <FaSearch />
                </InputGroup.Text>
                <Form.Control
                  placeholder="Buscar por nome, CNPJ, email, endereço, bairro, cidade, estado ou CEP..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </InputGroup>
            </Col>
          </Row>
        </Card.Body>
      </Card>
      
      {/* Formulário de cliente (condicional) */}
      {showForm && (
        <ClienteForm 
          cliente={currentCliente} 
          onSave={handleSaveCliente} 
          onCancel={() => { setShowForm(false); setCurrentCliente(null); }} 
        />
      )}
      
      {/* Tabela de clientes */}
      <Card className="shadow-sm">
        <Card.Body>
          <div className="table-responsive">
            <Table hover>
              <thead>
                <tr>
                  <th>CNPJ</th>
                  <th>Nome</th>
                  <th>Telefone</th>
                  <th>Cidade/Estado</th>
                  <th>Status</th>
                  <th className="text-end">Ações</th>
                </tr>
              </thead>
              <tbody>
                {filteredClientes.map((cliente) => (
                  <tr key={cliente.documentId}>
                    <td>{cliente.cnpj || '-'}</td>
                    <td>{cliente.nome}</td>
                    <td>{cliente.telefone || '-'}</td>
                    <td>
                      {cliente.cidade && cliente.estado 
                        ? `${cliente.cidade}/${cliente.estado}` 
                        : cliente.cidade || cliente.estado || '-'
                      }
                    </td>
                    <td>{cliente.status || '-'}</td>
                    <td className="text-end">
                      <Button 
                        variant="outline-primary" 
                        size="sm" 
                        className="me-2"
                        onClick={() => handleEditCliente(cliente)}
                      >
                        <FaEdit />
                      </Button>
                      <Button 
                        variant="outline-danger" 
                        size="sm"
                        onClick={() => handleDeleteCliente(cliente.documentId)}
                      >
                        <FaTrash />
                      </Button>
                    </td>
                  </tr>
                ))}
                {filteredClientes.length === 0 && (
                  <tr>
                    <td colSpan={6} className="text-center py-3">
                      Nenhum cliente encontrado
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
}

// Componente de formulário para adicionar/editar cliente
function ClienteForm({ cliente, onSave, onCancel }) {
  const [formData, setFormData] = useState({
    documentId: cliente?.documentId || null,
    nome: cliente?.nome || '',
    cnpj: cliente?.cnpj || '',
    email: cliente?.email || '',
    telefone: cliente?.telefone || '',
    status: cliente?.status || 'Ativo',
    // Campos de endereço
    rua: cliente?.rua || '',
    numero: cliente?.numero || '',
    complemento: cliente?.complemento || '',
    bairro: cliente?.bairro || '',
    cep: cliente?.cep || '',
    cidade: cliente?.cidade || '',
    estado: cliente?.estado || '',
  });

  const [loadingCep, setLoadingCep] = useState(false);
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Função para buscar dados do CEP na API ViaCEP
  const buscarCEP = async (cep) => {
    const cepLimpo = cep.replace(/\D/g, '');
    
    if (cepLimpo.length !== 8) {
      return;
    }

    setLoadingCep(true);
    
    try {
      const response = await fetch(`https://viacep.com.br/ws/${cepLimpo}/json/`);
      const data = await response.json();
      
      if (!data.erro) {
        setFormData(prev => ({
          ...prev,
          rua: data.logradouro || prev.rua,
          bairro: data.bairro || prev.bairro,
          cidade: data.localidade || prev.cidade,
          estado: data.uf || prev.estado
        }));
      } else {
        console.log('CEP não encontrado');
      }
    } catch (error) {
      console.error('Erro ao buscar CEP:', error);
    } finally {
      setLoadingCep(false);
    }
  };

  // Função para lidar com mudanças no CEP
  const handleCepChange = (e) => {
    const { value } = e.target;
    setFormData({ ...formData, cep: value });
    
    // Buscar automaticamente quando CEP tiver 8 dígitos
    const cepLimpo = value.replace(/\D/g, '');
    if (cepLimpo.length === 8) {
      buscarCEP(value);
    }
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Enviando dados do formulário:', formData);
    onSave(formData);
  };
  
  return (
    <Card className="mb-4 shadow-sm">
      <Card.Header as="h5">
        <FaMapMarkerAlt className="me-2" />
        {cliente ? 'Editar Cliente' : 'Novo Cliente'}
      </Card.Header>
      <Card.Body>
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Nome</Form.Label>
                <Form.Control
                  type="text"
                  name="nome"
                  value={formData.nome}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
            
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>CNPJ</Form.Label>
                <Form.Control
                  type="text"
                  name="cnpj"
                  value={formData.cnpj}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
            
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
            
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Telefone</Form.Label>
                <Form.Control
                  type="text"
                  name="telefone"
                  value={formData.telefone}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
            
            {/* Seção de Endereço */}
            <Col xs={12}>
              <h6 className="mt-3 mb-3 text-muted">
                <FaMapMarkerAlt className="me-2" />
                Endereço
                {loadingCep && <Spinner size="sm" className="ms-2" />}
              </h6>
            </Col>
            
            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label>CEP</Form.Label>
                <Form.Control
                  type="text"
                  name="cep"
                  value={formData.cep}
                  onChange={handleCepChange}
                  placeholder="12345-678"
                  maxLength="9"
                />
                <Form.Text className="text-muted">
                  Digite o CEP para preenchimento automático
                </Form.Text>
              </Form.Group>
            </Col>
            
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Rua</Form.Label>
                <Form.Control
                  type="text"
                  name="rua"
                  value={formData.rua}
                  onChange={handleChange}
                  placeholder="Ex: Av Zezé Jucá"
                />
              </Form.Group>
            </Col>
            
            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label>Número</Form.Label>
                <Form.Control
                  type="text"
                  name="numero"
                  value={formData.numero}
                  onChange={handleChange}
                  placeholder="123"
                />
              </Form.Group>
            </Col>
            
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Complemento</Form.Label>
                <Form.Control
                  type="text"
                  name="complemento"
                  value={formData.complemento}
                  onChange={handleChange}
                  placeholder="Apto 101, Bloco A"
                />
              </Form.Group>
            </Col>
            
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Bairro</Form.Label>
                <Form.Control
                  type="text"
                  name="bairro"
                  value={formData.bairro}
                  onChange={handleChange}
                  placeholder="Centro"
                />
              </Form.Group>
            </Col>
            
            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label>Cidade</Form.Label>
                <Form.Control
                  type="text"
                  name="cidade"
                  value={formData.cidade}
                  onChange={handleChange}
                  placeholder="Itatira"
                />
              </Form.Group>
            </Col>
            
            <Col md={1}>
              <Form.Group className="mb-3">
                <Form.Label>UF</Form.Label>
                <Form.Control
                  type="text"
                  name="estado"
                  value={formData.estado}
                  onChange={handleChange}
                  placeholder="CE"
                  maxLength="2"
                  style={{ textTransform: 'uppercase' }}
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Status</Form.Label>
                <Form.Select
                  name="status"
                  value={formData.status}
                  onChange={handleChange}
                >
                  <option value="Ativo">Ativo</option>
                  <option value="Inativo">Inativo</option>
                  <option value="Inadiplente">Inadiplente</option>
                </Form.Select>
              </Form.Group>
            </Col>
            
            
          </Row>
          
          <div className="d-flex justify-content-end gap-2 mt-3">
            <Button variant="secondary" onClick={onCancel}>
              <FaTimes className="me-2" /> Cancelar
            </Button>
            <Button variant="primary" type="submit">
              <FaSave className="me-2" /> Salvar
            </Button>
          </div>
        </Form>
      </Card.Body>
    </Card>
  );
}

export default Clientes;

